/* global MutationObserver */

import { useEffect } from 'react';
const removeFormScript = hubSpotPortalId => {
    const collectFormScript = document.head.querySelector(`#CollectedForms-${hubSpotPortalId}`);
    if (collectFormScript) {
        document.head.removeChild(collectFormScript);
    }
};

const addHubSpotScript = hubSpotPortalId => {
    const existingScript = document.querySelector(`script[src^="//js.hs-scripts.com/${hubSpotPortalId}.js"]`);
    if (!existingScript) {
        const script = document.createElement('script');
        script.src = `//js.hs-scripts.com/${hubSpotPortalId}.js`;
        script.async = true;

        script.onload = () => {
            removeFormScript();
        };

        script.onerror = () => {};

        document.head.appendChild(script);
    } else {
        removeFormScript();
    }
};

const useManageHubSpotScripts = (hubSpotPortalId = 20297952) => {
    useEffect(() => {
        addHubSpotScript(hubSpotPortalId);
    }, [hubSpotPortalId]);

    useEffect(() => {
        // Observe all changes to the document head i.e. scripts being loaded
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (
                    mutation.type === 'childList' ||
                    mutation.type === 'characterData' ||
                    mutation.type === 'attributes'
                ) {
                    removeFormScript(hubSpotPortalId);
                }
            });
        });

        observer.observe(document.head, {
            childList: true,
            subtree: true,
            characterData: true,
            attributes: true,
        });

        return () => {
            observer.disconnect();
        };
    }, [hubSpotPortalId]);
};

export default useManageHubSpotScripts;
